import React from 'react';
import NavigationItem from '../NavigationItem/NavigationItem';

export default function YourWorkMenu() {
    return (
        <div className="menu menu--constrained">
            <div className="menu__inner">
                <ul className="menu__item menu__item--action-list">
                    <NavigationItem
                        label={__('Contests')}
                        url="/contests/your-contests"
                        icon="folder-1"
                    />

                    <NavigationItem label={__('Projects')} url="/projects/active" icon="folder-1" />

                    <NavigationItem
                        label={__('Browse contests')}
                        url="/contests/browse"
                        icon="notebook-3"
                    />

                    <NavigationItem
                        label={__('Browse projects')}
                        url="/projects/browse"
                        icon="notebook-3"
                    />
                </ul>
            </div>
        </div>
    );
}
